import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.17647,1734.74871 L1807.05882,1734.74871 L1807.05882,831.219294 L1581.17647,831.219294 L1581.17647,1734.74871 Z M1016.47059,1734.74871 L1242.35294,1734.74871 L1242.35294,1282.984 L1016.47059,1282.984 L1016.47059,1734.74871 Z M451.764706,1734.74871 L677.647059,1734.74871 L677.647059,1057.10165 L451.764706,1057.10165 L451.764706,1734.74871 Z M112.941176,153.572235 L112.941176,1734.74871 L338.823529,1734.74871 L338.823529,944.160471 L790.588235,944.160471 L790.588235,1734.74871 L903.529412,1734.74871 L903.529412,1170.04282 L1355.29412,1170.04282 L1355.29412,1734.74871 L1468.23529,1734.74871 L1468.23529,718.278118 L1920,718.278118 L1920,1847.68988 L0,1847.68988 L0,153.572235 L112.941176,153.572235 Z M1586.60894,73 L1688.70776,121.112941 C1681.70541,136.247059 1511.95482,491.785882 1248.35012,557.404706 C1138.68424,584.736471 1030.03482,559.098824 926.128941,481.056471 C805.733647,390.703529 706.006588,364.501176 629.997176,402.449412 C496.274824,469.197647 451.776,714.844706 451.776,774.703529 L451.776,774.703529 L338.834824,774.703529 C338.834824,680.510588 395.870118,393.188235 579.512471,301.367059 C697.197176,242.750588 836.566588,272.792941 993.893647,390.703529 C1070.24188,448.077647 1144.44424,466.825882 1220.67953,447.851765 C1432.33129,395.334118 1585.02776,76.2752941 1586.60894,73 L1586.60894,73 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStatsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconStatsLine, _Component);

  var _super = _createSuper(IconStatsLine);

  function IconStatsLine() {
    _classCallCheck(this, IconStatsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconStatsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStats",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStatsLine.displayName = "IconStatsLine";
  return IconStatsLine;
}(Component);

IconStatsLine.glyphName = 'stats';
IconStatsLine.variant = 'Line';
IconStatsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStatsLine;
export { IconStatsLine };